import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./context/AuthContext";
import { SubscriptionContextProvider } from "./context/SubscriptionContext";
import ErrorBoundary from "./Component/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <AuthContextProvider>
        <SubscriptionContextProvider>
          <App />
        </SubscriptionContextProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById("root")
);
